import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const POPUP_DURATION_SUCCESS = 2000;
export const POPUP_DURATION_ERROR = 4000;
export const POPUP_DURATION_DELAY = 3000;
export const POPUP_DURATION_WARNING = 3000;

const DURATION_MAP = {
  success: POPUP_DURATION_SUCCESS,
  error: POPUP_DURATION_ERROR,
  warning: POPUP_DURATION_WARNING,
  info: POPUP_DURATION_DELAY,
};

const PopupContext = createContext();

export const usePopup = () => useContext(PopupContext);

export const PopupProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [popUpText, setPopUpText] = useState('');
  const [severity, setSeverity] = useState('success');

  /**
   * Mostra il popup
   * @param {boolean|string} severityOrBool - true/'success', false/'error', 'warning', 'info'
   * @param {string} [text] - messaggio da mostrare (opzionale)
   */
  const showPopup = (severityOrBool, text) => {
    let resolved;
    if (typeof severityOrBool === 'boolean') {
      resolved = severityOrBool ? 'success' : 'error';
    } else {
      resolved = severityOrBool || 'info';
    }

    setSeverity(resolved);

    if (text) {
      setPopUpText(text);
    }

    setOpen(true);

    setTimeout(() => {
      setOpen(false);
    }, DURATION_MAP[resolved] || POPUP_DURATION_DELAY);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <PopupContext.Provider value={{ showPopup, setPopUpText }}>
      {children}
      <Snackbar
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        action={
          <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {popUpText}
        </Alert>
      </Snackbar>
    </PopupContext.Provider>
  );
};
